import { render } from "./action-menu-portal-container.vue?vue&type=template&id=1165ef8a&scoped=true&ts=true"
import script from "./action-menu-portal-container.vue?vue&type=script&lang=ts"
export * from "./action-menu-portal-container.vue?vue&type=script&lang=ts"

import "./action-menu-portal-container.vue?vue&type=style&index=0&id=1165ef8a&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1165ef8a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
